import { SB } from '@play-co/replicant';

const fateStateSchedule = SB.object({
  // When this status effect will be set
  timestamp: SB.int(),
});

// Type for one futureStatusEffects record
export type FateStateScheduleRecord = SB.ExtractType<typeof fateStateSchedule>;

export default {
  fate: SB.object({
    // When futureStatusEffects was calculated
    // Used for rnd seed
    seed: SB.int(),
    // Status effects map
    // { 'sick': { timestamp }, 'normal': { timestamp } }
    schedule: SB.map(fateStateSchedule),

    // Temporary death feature start at timestamp
    // This will be set on login action and from this time fate will schedule death
    // Any fate update messages that will be process before this timestamp will use previous approach with death.
    // See more: https://playcoinc.slack.com/archives/C031L3JJ8HK/p1663112985321139
    deathFeatureActivationAt: SB.int().default(0).optional(),

    // Debug data for fate.
    // @deprecated
    debugData: SB.map(
      SB.object({
        stress: SB.number(),
        probability: SB.number().optional(),
      }),
    ).optional(),
  }),
};
